/**
 * 권한 상수 - 백엔드의 PERMISSIONS와 동일하게 유지한다
 * UI 컴포넌트에서 권한을 문자열로 하드코딩하지 말고 이 상수를 사용한다.
 */
export const PERMISSIONS = {
  DASHBOARD_READ: 'dashboard:read',
  CLAUDE_EXECUTE: 'claude:execute',
  DOCKER_READ: 'docker:read',
  DOCKER_READ_ALL: 'docker:read-all',
  DOCKER_CREATE: 'docker:create',
  DOCKER_UPDATE: 'docker:update',
  DOCKER_DELETE: 'docker:delete',
  SESSION_READ: 'session:read',
  SESSION_WRITE: 'session:write',
  USER_MANAGE: 'user:manage',
  SYSTEM_READ: 'system:read',
  SYSTEM_WRITE: 'system:write',
  TERMINAL_ACCESS: 'terminal:access',
  RBAC_MANAGE: 'rbac:manage',
  REPOSITORY_READ: 'repository:read',
  REPOSITORY_WRITE: 'repository:write',
  REPOSITORY_DELETE: 'repository:delete',
  SECURITY_READ: 'security:read',
  SECURITY_MANAGE: 'security:manage',
  BACKUP_READ: 'backup:read',
  BACKUP_MANAGE: 'backup:manage',
  SECRETS_READ: 'secrets:read',
  SECRETS_REVEAL: 'secrets:reveal',
  SECRETS_WRITE: 'secrets:write',
  SECRETS_DEPLOY: 'secrets:deploy',
} as const;
